import { render } from "./EditRequest2.vue?vue&type=template&id=225e10ac"
import script from "./EditRequest2.vue?vue&type=script&lang=js"
export * from "./EditRequest2.vue?vue&type=script&lang=js"

import "./EditRequest2.vue?vue&type=style&index=0&id=225e10ac&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__